import React, { useState, Dispatch, SetStateAction } from 'react';
import { RangeValue } from 'rc-picker/lib/interface';
import { getDefaultDateRangeValue } from '@utils/datetime';
import DatePicker from 'sharedComponents/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import viVN from 'antd/lib/locale/vi_VN';
import { ConfigProvider } from 'antd';
import 'dayjs/locale/vi';

import s from './index.module.less';

dayjs.locale('viVN');

const { RangePicker } = DatePicker;

type TimeFilterProps = {
  setDateFilter: Dispatch<SetStateAction<{ startDate: string; endDate: string }>>;
  setSessionDateRange?: (arg: { startDate: string; endDate: string }) => void;
  initialDateRange: { startDate: string; endDate: string };
};
function TimeFilter({ setDateFilter, setSessionDateRange, initialDateRange }: TimeFilterProps) {
  const defaultRange = getDefaultDateRangeValue(initialDateRange);
  const [range, setRange] = useState<RangeValue<Dayjs> | null>(defaultRange);

  function handleChangeTime(dates: RangeValue<Dayjs>) {
    const startDate = Array.isArray(dates) && dates[0] ? dates[0].format('DD/MM/YYYY') : '';
    const endDate = Array.isArray(dates) && dates[1] ? dates[1].format('DD/MM/YYYY') : '';
    setRange(dates);
    setDateFilter({ startDate, endDate });
    setSessionDateRange?.({ startDate, endDate });
  }

  return (
    <section>
      <ConfigProvider locale={viVN}>
        <RangePicker className={s.rangePicker} value={range} onChange={handleChangeTime} format="DD/MM/YYYY" />
      </ConfigProvider>
    </section>
  );
}

export default TimeFilter;
